import { DIProps } from "src/Core";
import React, { useCallback, useEffect, useState } from 'react'
import { Card, Button, ChoiceList, Combobox, InlineStack, Icon, Listbox, Popover, Text } from "@shopify/polaris";
import { FilterMajor, SearchMinor } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";
interface Props extends DIProps {
    setTitleFilter: (data: any) => void;
    inputValue: string;
    setInputValue: (data: string) => void;
    fetchSearchData: (data: string, options: any) => void;
    loading: boolean
    setloading: (data: boolean) => void
    options: any
    columns?: any[]
    setOptions: (data: any) => void
}

const SearchFeildUsingComboBox = (Props: Props) => {
    const { t } = useTranslation();
    const { setTitleFilter, setOptions, setloading, inputValue, options, loading, setInputValue, fetchSearchData } = Props;

    const [load, setLoad] = useState<boolean>(true);
    const [selectedValue, setselectedValue] = useState<any>();
    const [selectedOptForSearch, setSelectedOptForSearch] = useState<any>(JSON.parse(Props.di.globalState.get('searchOptions') || `
        [
            "items.title",
            "brand",
            "product_type",
            "items.barcode",
            "items.sku",
            "items.shopify_sku"
        ]`
    ));

    useEffect(() => {
        setloading(true)
        setOptions([])
        const timer = setTimeout(() => {
            fetchSearchData(inputValue, selectedOptForSearch)
        }, 500);
        return () => clearInterval(timer);
    }, [inputValue, selectedOptForSearch])

    useEffect(() => {
        load ? setTimeout(() => {
            setLoad(false)
        }, 2000) : ''
    }, [loading])

    const updateSelection = (e: any) => {
        setselectedValue(e)
        setTitleFilter([e])
    }



    const loadingMarkup = inputValue.length > 0 ? load ?
        <Listbox.Loading accessibilityLabel="Loading" /> :
        <InlineStack blockAlign="center" align="start" gap="100">
            <div><Icon source={SearchMinor} /></div>
            <div>{t("No products found.")}</div>
        </InlineStack>
        : <></>

    const optionMarkup = options.length > 0 ? options.map((opt: any) => {
        return <div key={opt.label} style={{ borderBottom: "1px solid #ddd", padding: '10px 0 10px 10px' }}>{opt?.label}</div>
    }) : loadingMarkup;

    const listboxMarkup = optionMarkup ? (
        <Listbox enableKeyboardControl onSelect={updateSelection}>
            {options.length > 0 ? options.map((opt: any) => {
                return <Listbox.Option key={opt.source_product_id} value={opt?.container_id}>
                    <Listbox.TextOption key={opt?.id}>{opt?.label}</Listbox.TextOption></Listbox.Option>
            }) : loadingMarkup}
        </Listbox>
    ) : loadingMarkup


    const handleTextField = (val: string) => {
        setInputValue(val);
        setLoad(true)
    }

    const [activePop, setActivePop] = useState(false);
    const toggleActivePop = useCallback(() => setActivePop((activePop) => !activePop), []);
    return (
        <Combobox
            activator={
                <div style={{ width: "100%" }}>
                    <Combobox.TextField
                        prefix={<Icon source={SearchMinor} tone="base" />}
                        label={t("Search tags")}
                        labelHidden
                        value={inputValue}
                        onChange={(val: string) => handleTextField(val)}
                        placeholder={t("Search by Title, Vendor, Product type, or Barcode")}
                        autoComplete="off"
                        clearButton
                        onClearButtonClick={() => setInputValue('')}
                        connectedLeft={
                            <Popover
                                active={activePop}
                                activator={<Button onClick={toggleActivePop} size="large" disclosure>{t("All")}</Button>}
                                autofocusTarget="first-node"
                                onClose={toggleActivePop}
                            >
                                <Card roundedAbove="sm">
                                    <ChoiceList
                                        allowMultiple
                                        title={t("Search With:")}
                                        choices={[
                                            {
                                                label: t('Title'),
                                                value: 'items.title',
                                            },
                                            {
                                                label: t('Vendor'),
                                                value: 'brand',
                                            },
                                            {
                                                label: t("Product type"),
                                                value: 'product_type'
                                            },
                                            {
                                                label: t("Barcode"),
                                                value: 'items.barcode'
                                            },
                                            {
                                                label: t("SKU"),
                                                value: 'items.sku'
                                            }
                                        ]}
                                        selected={selectedOptForSearch}
                                        onChange={(value: any) => {
                                            Props.di.globalState.set("searchOptions", JSON.stringify(value), true)
                                            setSelectedOptForSearch(value)
                                        }}
                                    />
                                </Card>
                            </Popover>
                        }
                    />
                </div>
            }
        >
            {listboxMarkup}
        </Combobox>
    );
}

export default SearchFeildUsingComboBox